import React, { useMemo } from 'react';
import { connect } from 'umi';
import { TOptionsItem, IMultipleCommonType } from '../../types';
import { useUpdateEffect } from 'ahooks';
import {
  RadioAllMultipleSelect,
  RadioAllMultipleSelectType,
} from '../../components/RadioAllMultipleSelect';
import {
  multipleMapStateToProps,
  moreKeyMultipleDispatchToProps,
} from '../../connect/multiple';

export type HashtagCountryRegionSelectType = Omit<
  RadioAllMultipleSelectType,
  'options'
> & {
  options: Record<string, TOptionsItem[]> | TOptionsItem[];
};

export function HashtagCountryRegionSelect({
  options,
  change,
  filterValue,
  value,
  ...props
}: HashtagCountryRegionSelectType & IMultipleCommonType) {
  // 根据 source 获取对应的 options
  const realOptions = useMemo(() => {
    // 如果是对象（按 source 分组），根据当前 source 返回对应选项
    if (options && !Array.isArray(options)) {
      const { source } = filterValue || {}; 
      return options[source] || options.common || [];
    }
    // 如果是数组，直接返回
    return options as TOptionsItem[];
  }, [options, filterValue?.source]);

  // 当 source 变化时，检查当前选中的值是否在新选项中存在，不存在则重置
  useUpdateEffect(() => {
    if (Array.isArray(realOptions) && value?.length > 0) {
      const validValues = value.filter((v: string) =>
        realOptions.some((item) => item.value === v),
      );
      if (validValues.length !== value.length) {
        change(validValues, true);
      }
    }
  }, [filterValue?.source]);

  return (
    <RadioAllMultipleSelect
      filterValue={filterValue}
      change={change}
      value={value}
      options={realOptions}
      {...props}
    />
  );
}

export default connect(
  multipleMapStateToProps,
  moreKeyMultipleDispatchToProps,
)(HashtagCountryRegionSelect);
